import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/layout/Hero';

const HomePage = () => {
  return (
    <Layout>
      <Hero />
    </Layout>
  );
};

export default HomePage;
